import React, { useCallback, useState, useEffect, useRef } from 'react';
import Header from '../Login/Header';
import UploadFile from "../Assets/UploadWht.svg";
import { useDropzone } from "react-dropzone";
import Logout from '../Assets/logout-svgrepo-com.svg';
import Delete from '../Assets/delete.svg';
import ReloadWht from '../Assets/reload-wht.svg';
import Preview from '../Assets/preview.svg';
import XtractorIcon from '../Assets/XtractorWhite.svg';
import Export from '../Assets/export2.svg';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { Editor } from 'textcrafter';
import CloseWhtBtn from '../Assets/Close-wht.svg';
import PdfImg from '../Assets/pdf.svg';
import 'textcrafter/dist/styles.min.css';
import SumPdfViewer from '../PdfPage/SumPdf';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Settings from '../Assets/settings-.svg';
import Settings1 from '../Assets/settings-svgrepo-com.svg';

function DocSum2() {
      const navigate = useNavigate();
      const [files, setFiles] = useState([]);
      const [FileURL, setFileURL] = useState('');
      const [editorContent, setEditorContent] = useState('');
      const [isDisabled, setIsDisabled] = useState(true);
      const [isPlaceholderActive, setIsPlaceholderActive] = useState(true);
      const [isHide, setIsHide] = useState('');
      const [isEnabled, setIsEnabled] = useState(false);
      const [GeneratedRes, setGeneratedRes] = useState(false);
      const [isLoading, setIsLoading] = useState(false);
      const [ChangeLayout, setChangeLayout] = useState(false);
      const [SumXData, setSumXData] = useState([]);
      const [PreviewText, setPreviewText] = useState(false);
      const placeholder = 'Write your text here...';

      const handleEditorChange = (content) => {
        setEditorContent(content);
        setIsDisabled(false)
        setIsPlaceholderActive(content === '' ? true : false);
        if(content.length > 0){
            setIsHide('hide-pdf')
            setIsEnabled(true)
            // if(content.length > 0 && content.includes('<br>')){
            //     setIsHide('hide-pdf')
            // }
        }
        else if(content.length > 4 && content.toString().includes('<br>')){
            setIsHide('') 
            setIsEnabled(false)
        }
        console.log(content.toString(), content.length, content.includes('<br>'));
      };

      const handleClose = () => {
        setFileURL('');
        setFiles([]);
        setIsHide('')
        setIsDisabled(true);
      };

      const handleClear = () => {
        setFileURL('');
        setIsHide('')
        setFiles([]);
        setEditorContent('');
        setSumXData('');
        setIsPlaceholderActive(true);
        setIsDisabled(true)
        setGeneratedRes(false)
        setPreviewText(false)
        setChangeLayout(false)
      }

      useEffect(() => {

      },[isPlaceholderActive, isEnabled])

      const onDrop = useCallback((acceptedFiles) => {
        setFiles(acceptedFiles.map(file => Object.assign(file, {
          preview: file
        })));
        acceptedFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = () => {
            const blob = new Blob([reader.result], { type: file.type });
            const url = URL.createObjectURL(blob);
            setFileURL(url);
            setIsDisabled(false);
            if(url.length > 0){
                setIsHide('hide-text')
            }
            console.log(url, 'url')
          };
          reader.readAsArrayBuffer(file);
        });
      }, []);
    
      const { getRootProps, getInputProps, open } = useDropzone({
        onDrop,
        maxFiles: 1,
        accept: ".pdf, .doc, .docx, .txt",
        noClick: true,
        noKeyboard: true,
        noDrag: isEnabled
      });

    //   const check = document.getElementById('content-area');
    //   check.onClick(setIsPlaceholderActive(false))

      // const handleGenerate = () => {
      //   setGeneratedRes(true)
      // }
      const handleGenerate = async () => {
          setChangeLayout(true)
          if (editorContent.length > 0) { 
            // setSumXData(Output);
            setGeneratedRes(true);
            const payload = {
              'text': editorContent,
              // 'model': 'deepseek-r1:1.5b',
              'model': 'ollama2',
            }
          try {
            setIsLoading(true);
            setPreviewText(true);
                const { data } = await axios.post('https://147.93.31.135:3000/api/generate-summary/', payload, {
                // const { data } = await axios.post('https://velrd.in/api/generate-summary/', payload, {
                  headers: { 'Content-Type': 'multipart/form-data' },
                });
                if (data?.summary) {
                  console.log(data, 'data')
                  setSumXData(data.summary);
                  setGeneratedRes(true);
                  setIsLoading(false);
                } else {
                  console.error("process_result is missing in the response:", data);
                }
          } catch (error) {
              console.error("Error uploading file:", error);
          } finally {
            setIsLoading(false);
          }
          } else {
            // setSumXData(Output);
            setGeneratedRes(true);
          try {
            setIsLoading(true);
            const formData = new FormData();
        
            if (typeof FileURL === 'string' && FileURL.startsWith('blob:')) {
              const response = await fetch(FileURL);
              const blob = await response.blob();
              formData.append("file", new File([blob], files[0].name , { type: 'application/pdf' }));
            } else if (FileURL instanceof File || FileURL instanceof Blob) {
              formData.append("file", FileURL, FileURL.name || 'extracted_file.pdf');
            }
        
            const { data } = await axios.post('https://147.93.31.135:3000/api/generate-summary-pdf/', formData, {
            // const { data } = await axios.post('https://velrd.in/api/generate-summary-pdf/', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            });
        
            if (data?.summary) {
              console.log(data, 'data')
              setSumXData(data.summary);
              setGeneratedRes(true);
              setIsLoading(false);
            } else {
              console.error("process_result is missing in the response:", data);
            }
          } catch (error) {
            console.error("Error uploading file:", error);
          } finally {
            setIsLoading(false);
          }
      
          }
      };
      
    const data = {
        summery: "Summary on Sustainable Development Goals (SDGs) by UNDP\n\n1. **Context: Leaders Discussing Future Challenges\n   - Leaders from 193 countries gathered in 2015 to address facing challenges such as famines, droughts, wars, and plagues.\n   - They emphasized a better future through shared hope without exploitation.\n\n2. **SDGs and UNDP's Role\n   - Introduced SDGs (17 goals) to imagine a 15-year future free from poverty and climate extremes.\n   - Mentioned United Nations Development Programme (UNDP) as leading organizations working towards these goals in nearly 170 countries and territories.\n\n3. **Achievements So Far\n   - Achieved half the global poverty reduction through past 15 years, with UNDP's support keying on achieving SDGs.\n   - Highlighted UNDP's role in fostering hope and cooperation globally for a sustainable future.\n\n4. **Roadmap for Progress\n   - Aim to finish SDGs by 2030, building on progress since last year when half poverty was reduced.\n   - Emphasized the need for sustained effort despite challenges like earthquakes and floods.\n\n5. **Conclusion: Significance of Work*\n   - Summarizes UNDP's role as a leader in global movement towardsSDGs, fostering hope and cooperation toward sustainable development.\n\nThis summary structures key points clearly, using headings and bullet points for detailed information, while maintaining readability with clear paragraphs for explanations."
    }

  return (
    <div>
        <div className="container-fluid header px-4" style={{ borderBottom: 'none', zIndex: '10', position:'relative', background: 'rgb(13, 17, 23)'}}>
            <div className='row p-0 m-0' style={{width: '100%'}}>
                <div className='col-6 header-col p-0 m-0'>
                <p style={{color: '#0473ea', fontSize: '17px', marginBottom: '0', cursor: 'pointer'}} onClick={()=>navigate('/Home')}>Xtract<span style={{color: '#c9c9c9'}}>hub</span></p>
                    {/* <img src={XtractorIcon} width='70px' onClick={()=>navigate('/Home')} style={{cursor: 'pointer'}} /> */}
                </div>
                <div className='col-6 header-col p-0 m-0'>
                    <p className="text-end mb-0" style={{ color: '#ffffffc6', fontSize: '11px', fontWeight: '500', cursor: 'pointer' }} onClick={()=>navigate('/')}><img src={Logout} className='me-2' width='22px' />Sign Out</p>
                </div>
            </div>
        </div>
        {/* <div className={`d-flex flex-wrap justify-content-between align-items-center px-5`} style={{ width: '100%', height: '6vh', background: 'rgb(4,115,234, 0.85)',position:'relative', zIndex: '10'}}> */}
        <div className={`d-flex flex-wrap justify-content-between align-items-center px-3`} style={{ width: '100%', height: '6vh', background: 'rgb(22, 29, 39)',position:'relative', zIndex: '10', boxShadow: 'rgba(166, 177, 193, 0.06) 0px 0px 0px 1px inset'}}>
            <div className='d-flex justify-content-end' style={{width:'53%'}}>
                {/* <div className="mb-0 d-flex align-items-center px-3" style={{ color: '#fff', fontSize: '11px', cursor: 'pointer', height: '6vh' }}>DocX</div> */}
                <div className="mb-0 d-flex align-items-center px-3" style={{ color: '#0473ea', fontSize: '11px', cursor: 'pointer', height: '6vh', fontWeight: '700'}}>SumX</div>
                {/* <div className="mb-0 d-flex align-items-center px-3" style={{ color: '#fff', fontSize: '11px', cursor: 'pointer', height: '6vh' }}>Q & A</div> */}
            </div>
            <div className='d-flex'>
                {/* <button className='clear-btn d-flex align-items-center'><img src={Preview} height={'15px'} style={{padding: '0 6px 0 0'}}/>Preview</button> */}
                <button disabled={isDisabled} className={`${isDisabled && 'disabled-btn'} clear-btn d-flex align-items-center`} onClick={handleClear}><img src={Delete} height={'15px'} style={{padding: '0 6px 0 0'}}/>Clear</button>
                <button disabled={isDisabled} className={`${isDisabled && 'disabled-g-btn'} generate-btn`} onClick={handleGenerate}><img src={ReloadWht} height={'15px'} style={{padding: '0 6px 0 0'}}/>Generate</button>
            </div>
            {/* <p className="mb-0" style={{ color: '#fff', fontSize: '11px', fontWeight: '500', cursor: 'pointer' }}><img src={Logout} className='me-2' width='22px' />Sign Out</p> */}
        </div>

        <div className='row p-0 m-0' style={{width: '100%', background: 'rgb(13, 17, 23)'}}>
            <div className='m-0 py-3 ps-3 pe-2' style={{width: '48%', padding: '20px', height: '80vh'}}>
                <div className={`d-flex justify-content-center align-items-center pdf-parent-container ${editorContent.length > 0 ? (editorContent.length <= 4 && editorContent.includes('<br>') ? '' : 'hide-contents') : ''}`} style={{padding: `${files.length > 0 ? '0px 0 0px 10px' : '20px'}`}}>
                {PreviewText &&
                <div style={{height: '100%', width: '100%',color: '#fff', fontSize: '13.5px', textAlign: 'start', overflowY: 'auto', scrollbarColor: 'rgb(56, 67, 82) rgb(22, 29, 39)'}}>
                  <p style={{color: '#fff', padding: '0 0 12px 0',borderBottom: '1.2px solid rgba(167, 201, 239, 0.7)'}}>Preview your Text Here</p>
                  {editorContent}
                </div>
                }
                {!PreviewText &&
                <>
                {files.length > 0 ? 
                <div class="flex-wrap justify-content-center align-items-center" style={{position: 'relative',height: '100%', overflowY: 'auto',width: '100%', scrollbarColor: 'rgb(56, 67, 82) rgb(22, 29, 39)'}}>
                        <SumPdfViewer src={FileURL} highlightText={''} endIndex={''} />
                        <div style={{display: 'flex',position: 'sticky', bottom: '-1px', left: '0', background: 'rgb(22, 29, 39)', padding: '14px'}}>
                            <div className='d-flex align-items-center justify-content-center' style={{width: '10%'}}>
                                <img class="mb-1" src={PdfImg}  height={'32px'}/>
                            </div>
                            <div style={{width: '90%', padding: '0 15px'}}>
                                <p class="text-start justify-content-center mb-1" style={{color: 'rgb(256, 256, 256, 0.7)',fontSize: '12px',fontWeight: '700',width: '100%'}}>{files[0].path}</p>
                                <p class="text-start mb-0" style={{fontSize: '11px',color: '#A09FA1',width: '100%'}}>{files[0].size}</p>
                            </div>
                            <div>
                                <img src={CloseWhtBtn} style={{position: 'absolute',top: '15px',right: '15px', zIndex: '999',cursor: 'pointer'}} width="20" onClick={handleClose} />
                            </div>
                        </div>
                </div> :
                <div id="file-upload-div" class="dash-box d-flex flex-wrap justify-content-center align-items-center" style={{border: '1.5px dashed #a7c9ef2e', height: '100%', width: '100%'}} {...(isEnabled ? getRootProps() : {})}>
                          <input {...getInputProps()} />
                          <div id="drop-area" class="flex-wrap justify-content-center align-items-center">
                              <img class="mb-3" src={UploadFile} width='50px' />
                              <h1 style={{fontSize: '12px',fontWeight: '700',width: '100%', color: '#fff'}}>Drag & Drop Your Files Here</h1>
                              <p style={{fontSize: '11px',color: '#A09FA1',fontWeight: '500',width: '100%'}}>Supports pdf, doc, docx, txt</p>
                              <input type="file" id="fileInput" style={{display: 'none'}} />
                              {editorContent.length > 0 ? (editorContent.length <= 4 && editorContent.includes('<br>') ? 
                                <button className='blueButton' style={{padding: '8px 18px', fontSize: '12px', background: 'transparent', color: '#0473ea'}} onClick={open} type="button">
                                    <img src={Export} height={'25px'} style={{padding: '0 6px 0 0'}}/> Upload File
                                </button>: ''
                                ) :
                                <button className='blueButton' style={{padding: '8px 18px', fontSize: '12px', background: 'transparent', color: '#0473ea'}} onClick={open} type="button">
                                    <img src={Export} height={'25px'} style={{padding: '0 6px 0 0'}}/> Upload File
                                </button>
                              }
                          </div>
                </div> }
                </>}
                </div>
            </div>
            {!ChangeLayout &&
            <div className='d-flex align-items-center justify-content-center' style={{width: '4%', height: '100%', height: '80vh'}}>
                <p style={{color: 'rgb(255, 255, 255, 0.35)',width: '100%'}}>or</p>
            </div>}
            <div className='m-0 py-3 ps-2 pe-3' style={{width: !ChangeLayout ? '48%' : '52%',padding:'20px', height: '80vh'}}>
                <div style={{position: 'relative',height: '100%', padding: !ChangeLayout ? '20px' : '20px 0 20px 20px', background: 'rgb(22, 29, 39)', boxShadow: 'rgba(166, 177, 193, 0.06) 0px 0px 0px 1px inset'}}>
                    <div className={`editor-container ${isHide.includes('text') && isHide}`} style={{height: '100%', width: '100%', color: '#ffffffc7', textAlign: 'start', fontSize: '13px', overflowY: 'auto', scrollbarColor: 'rgb(56, 67, 82) rgb(22, 29, 39)'}}>
                        {editorContent.length > 0 ? (editorContent.length <= 4 && editorContent.includes('<br>') ? (
                            <div className="editor-placeholder">
                                Paste your text here...
                            </div>
                            ) : '') : GeneratedRes ? '' :
                            <div className="editor-placeholder">
                                Paste your text here...
                            </div>
                        }

                        {isLoading && 
                        <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                          <div className='text-center'>
                          <img className='settings-icon1' src={Settings} height='100px' style={{marginTop: '60px'}} />
                          <img className='settings-icon2' src={Settings1} height='100px' style={{marginTop: '-40px'}} />
                          <p className='text-center pt-4' style={{width: '100%', color: 'rgba(255, 255, 255, 0.7)'}}>Generating your Response, Please wait...</p>
                          </div>
                        </div>}

                        {GeneratedRes &&
                        (SumXData && SumXData.length > 0 && SumXData.split('\n').map((line, index) => (
                            <React.Fragment key={index} style={{color: '#fff', overflowY: 'auto'}}>
                                {line}
                                <br />
                            </React.Fragment>
                        )))}

                        {!GeneratedRes && files.length <= 0 && 
                        <Editor
                            value={editorContent}
                            onChange={handleEditorChange}
                        />}
                    </div>
                </div>
            </div>
        </div>

        <div className={`d-flex flex-wrap justify-content-between align-items-center px-4`} style={{ width: '100%', height: '6vh', background: 'rgb(22, 29, 39)',position:'relative', zIndex: '10'}}>
            <p className="text-end mb-0" style={{ fontSize: '10px', width: '100%', color: 'rgb(158, 156, 156, 0.6)' }}>© 2025 All rights reserved by <span style={{color: '#f62b2b'}}> Spiral</span><span style={{color: '#1E35D5'}}>cubes</span></p>
        </div>
    </div>
  )
}

export default DocSum2;
